// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"47506":"f66d4429738d4ece","59795":"9eaad40e7710b40f","90728":"9d0d9b532baa4cbc"}[chunkId] + ".css";
};